var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:{ 'is-active': _vm.isActive },on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.link.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }